import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=2968665b&scoped=true"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"
import style0 from "./Player.vue?vue&type=style&index=0&id=2968665b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968665b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2968665b')) {
      api.createRecord('2968665b', component.options)
    } else {
      api.reload('2968665b', component.options)
    }
    module.hot.accept("./Player.vue?vue&type=template&id=2968665b&scoped=true", function () {
      api.rerender('2968665b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quickstart/Player.vue"
export default component.exports